import Vue from "vue";
import CompanyService from "@/service/CompanyService";
import MenuRightSerivce from "@/service/MenuRightService";
import SweetAlertService from "@/service/SweetAlertService";
import StaffService from "@/service/StaffService";
import StoreGetter from "@/constants/StoreGetter";
import { MaritalStatus } from "@/model/MaritalStatus";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import Setting from "@/constants/Settings";
import MaritalStatusValidation from "./S081300-MaritalStatusValidation.js";
import Paginate from "vuejs-paginate";
var MaritalStatusValidationObj = new MaritalStatusValidation();
export default {
    name: "MaritalStatus",
    mounted() {
        MaritalStatusValidationObj.MaritalStatusValidation();
        this.assignRights();
        this.getAllMaritalStatus();
    },
    components: {
        paginate: Paginate,
    },
    data: () => ({
        menuRights: { allRights: {}, rightsForThisMenu: {} },
        menuId: Setting.MenuID.S_MaritalSatus,
        dictEnum: dictEnum,
        MaritalStatus: new MaritalStatus(),
        isEditMode: false,
        MaritalStatusList: [],
        selectAllMaritalStatus: false,
        tempMaritalStatusModel: new MaritalStatus(),
        take: 10,
        skip: 0,
        totalNoOfPages: 0,
        noOfPages: 5,
        currentSelectedPage: 0,
        currentPage: this.currentSelectedPage + 1,
        totalRecords: 0,
    }),
    computed: {
        t() {
            return t;
        },
        user() {
            return this.$store.getters[StoreGetter.user];
        },
    },
    methods: {
        hasRight(key, menuId) {
            if (Object.keys(this.menuRights.allRights).length === 0) {
                return false;
            } else {
                return MenuRightSerivce.hasRightInMenu(
                    this.menuRights.allRights,
                    menuId ? menuId : this.menuId,
                    key
                );
            }
        },
        assignRights() {
            this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
            this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
                x => x.MenuID == this.menuId
            );
        },
        async getAllMaritalStatus() {
            var self = this;
            var obj = {}
            const response = await StaffService.getAllMaritalStatus(obj);
            if (response.data.IsSuccess) {
                self.MaritalStatusList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        selectAllMaritalStatusRecord: function () {
            var self = this;
            var IsSelected = self.selectAllMaritalStatus;
            self.MaritalStatusList.forEach(function (val, index) {
                val["isSelected"] = IsSelected;
            });
        },
        deleteMultipleMaritalStatusPopup: function () {
            var arrayList = [];
            var self = this;
            self.MaritalStatusList.forEach(function (key, value) {
                if (key.isSelected) {
                    arrayList.push(key);
                }
            });
            if (arrayList.length > 0) {
                $('#deleteMaritalStatusListModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectDeleteRecord));
            }
        },
        async deleteMultipleMaritalStatus() {
            var arrayList = [];
            var self = this;
            $('#deleteMaritalStatusListModel').modal('hide');
            self.MaritalStatusList.forEach(function (key, value) {
                if (key.isSelected) {
                    arrayList.push(key);
                }
            });
            const obj = {
                maritalStatusList: arrayList,
            };
            const response = await StaffService.deleteMaritalStatus(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetMaritalStatus();
                await self.getAllMaritalStatus();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        OnMaritalStatusSelect: function (model) {
            this.tempMaritalStatusModel = model;
        },
        addMaritalStatus: function () {
            var self = this;
            $('#MaritalStatusModel').modal('show');
            self.isEditMode = false;
            self.MaritalStatus = new MaritalStatus();
            self.$validator.reset();
            self.vErrors.clear();
        },
        async saveMaritalStatusDetail(obj) {
            var self = this;
            const response = await StaffService.addMaritalStatus(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetMaritalStatus();
                await self.getAllMaritalStatus();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        async editMaritalStatus(obj) {
            var self = this;
            const response = await StaffService.updateMaritalStatus(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetMaritalStatus();
                await self.getAllMaritalStatus();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        async saveMaritalStatus() {
            var self = this;
            self.$validator.validateAll().then(result => {
                if (result) {
                    $('#MaritalStatusModel').modal('hide');
                    const obj = {
                        model: {
                            StatusCode: self.MaritalStatus.StatusCode,
                            CDesc: self.MaritalStatus.CDesc,
                            EDesc: self.MaritalStatus.EDesc,
                        }
                    };
                    if (self.isEditMode) {
                        self.editMaritalStatus(obj);
                    }
                    else {
                        self.saveMaritalStatusDetail(obj);
                    }
                }
            });
        },
        async editMaritalStatusDetail() {
            var self = this;
            self.isEditMode = true;
            if (self.tempMaritalStatusModel.StatusCode != "") {
                self.MaritalStatus = this.tempMaritalStatusModel;
                self.$validator.reset();
                self.vErrors.clear();
                $('#MaritalStatusModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", self.t.t(dictEnum.MSG_SelectEditRecord));
            }
        },
        resetMaritalStatus: function () {
            var self = this;
            self.selectAllMaritalStatus = false;
            self.isEditMode = false;
            self.MaritalStatus = new MaritalStatus();
            self.tempMaritalStatusModel = new MaritalStatus();
            self.$validator.reset();
            self.vErrors.clear();
            self.take = 10;
            self.skip = 0;
            self.totalNoOfPages = 0;
            self.noOfPages = 5;
            self.currentSelectedPage = 0;
            self.currentPage = self.currentSelectedPage + 1;
            self.totalRecords = 0;
        },
        closeMaritalStatusPopup: function () {
            var self = this;
            self.selectAllMaritalStatus = false;
            self.isEditMode = false;
            self.MaritalStatus = new MaritalStatus();
            self.tempMaritalStatusModel = new MaritalStatus();
            self.$validator.reset();
            self.vErrors.clear();
            $('#MaritalStatusModel').modal('hide');
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S081300-MaritalStatus/S081300-MaritalStatus.js